import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nService } from '../../services/i18n.service';

interface ProcessStep {
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-process',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './process.component.html',
  styleUrl: './process.component.scss'
})
export class ProcessComponent implements OnInit {
  processSteps: ProcessStep[] = [
    {
      icon: 'fa-solid fa-search',
      title: 'Research',
      description: 'Collecting requirements, market and user analysis, clarifying business goals.'
    },
    {
      icon: 'fa-solid fa-diagram-project',
      title: 'Architecture',
      description: 'Developing technical design, selecting technologies, planning stages.'
    },
    {
      icon: 'fa-solid fa-code',
      title: 'Development',
      description: 'Creating, testing and documenting software components.'
    },
    {
      icon: 'fa-solid fa-rocket',
      title: 'Launch & support',
      description: 'Deploying the product, collecting feedback, improvement and growth.'
    }
  ];

  constructor(public i18n: I18nService) {}

  ngOnInit(): void {
    this.i18n.initializeLanguage();
  }
}
